import { createContext } from 'react';

type GeneralContextProps = {
  isSafari: boolean;
};

export default createContext<Partial<GeneralContextProps>>({
  isSafari: false,
});
